import { useLanguage } from '../contexts/LanguageContext';
import { WineSizes } from '../utils/constants';

function ProductItem({ wine, onClick }) {
  const { language } = useLanguage();

  return (
    <div className="product-item" onClick={onClick}>
      <div className="product-item-image-container">
        <img src={wine.image} alt={wine.name} />
      </div>
      <div className="product-item-info">
        <div className="product-item-text">
          <h2>{wine.name}</h2>
          <div>
            <p>{wine.year}</p>
            <p>{wine.type.label[language]}</p>
            <p>{wine.size === WineSizes.MAGNUM ? wine.size.label[language] : ""}</p>
            {wine.region && <p>{wine.region.label[language]}</p>}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProductItem;